import { mapActions } from 'vuex'

export default {
  ...mapActions('overlay', ['hide']),
  setFamilies() {
    this.setFamiliesValues()
  },
  setSiblings(siblings) {
    this.siblings = siblings
  },
  setSelectedFamily(selectedFamily) {
    this.selectedFamily = selectedFamily
  },
  deselectFromFamilies(data) {
    if (data === undefined) {
      this.$store.dispatch('submissions/resetFamilyGroup')
    }
    this.postFamiliesValues(this.families.values)
    this.$refs.familiesSelect.onSearchBlur()
  },
  optionDeselectedDD(option) {
    this.families.values = this.families.values.filter(v => v.value !== option.value)
    this.$refs.familiesSelect._value = this.$refs.familiesSelect._value?.filter(v => v.value !== option.value)
    this.postFamiliesValues(this.families.values)
  },
  onSearchBlurFamilies() {
    this.families.options = []
  },
  postFamiliesValues(val) {
    /**
     * Updates the tags in submission.
     */
    this.families.state = 'set'
    this.families.update(val, this.commitChange)
  },
  setFamiliesValues() {
    /**
     * Set families values.
     */
    this.families.setValues({
      obj: this.submissionFamilies.families,
      value: 'id',
      name: 'familyName',
      multiple: true
    })
  },
  checkSiblings(familyId, submissionId) {
    return this.$store.dispatch('families/getFamilySiblings', { familyId, submissionId })
  },
  cancelModal() {
    const removeSelected = this.tempRelatedFamilies.findIndex(res => res.value === this.selectedFamily.value)
    if (this.families.values && this.families.values.length > 0) {
      this.families.remove(removeSelected)
    }
    this.setSelectedFamily({})
    this.hide()
  },
  async checkUpdateFamiliesValues(ddSelectedFamilies) {
    /**
     * Updates the families in submission.
     */
    this.isFamilySiblingModalVisible = false
    const isDeleted = ddSelectedFamilies.every(res => res.edit)
    if (isDeleted || ddSelectedFamilies.length === 0) {
      this.handleDeletedFamilies(ddSelectedFamilies)
    } else {
      await this.handleNonDeletedFamilies(ddSelectedFamilies)
    }
  },

  handleDeletedFamilies(ddSelectedFamilies) {
    if (ddSelectedFamilies.length === 0) {
      this.$store.dispatch('submissions/resetFamilyGroup')
    } else {
      this.postFamiliesValues(ddSelectedFamilies)
    }
  },

  async handleNonDeletedFamilies(ddSelectedFamilies) {
    this.familiesHideDrop = true
    this.tempRelatedFamilies = ddSelectedFamilies

    this.setFirstNonEditedFamilyAsSelected(ddSelectedFamilies)
    const valueCheckData = ddSelectedFamilies.map(family => family.value)
    if (this.selectedFamily.value) {
      await this.checkSiblings(this.selectedFamily.value, this.submission.id)
      const siblingsData = this.getSiblingsData(valueCheckData)
      const relatedFamilySiblingsWIthoutSameFamily = this.relatedFamilySiblings.filter(
        sibling => parseInt(sibling.id) !== parseInt(this.submission.userMetaData.family.pimFamilyId)
      )
      if (siblingsData.length > 0) {
        this.setSiblings(
          siblingsData.filter(
            sibling => parseInt(sibling.value) !== parseInt(this.submission.userMetaData.family.pimFamilyId)
          )
        )
        await this.$nextTick()
        if (relatedFamilySiblingsWIthoutSameFamily.length === 1) {
          this.updateFamiliesValues()
        } else {
          this.isFamilySiblingModalVisible = true
        }
      } else {
        this.updateFamiliesValues()
      }
    }
  },

  setFirstNonEditedFamilyAsSelected(ddSelectedFamilies) {
    for (const family of ddSelectedFamilies) {
      if (!family.edit) {
        this.setSelectedFamily(family)
        break
      }
    }
  },

  getSiblingsData(valueCheckData) {
    return this.relatedFamilySiblings
      .filter(item => !valueCheckData.includes(item.id))
      .map(res => ({
        edit: res.familyName,
        label: res.familyName,
        value: res.id
      }))
  },
  async updateFamiliesValues() {
    const valueCheckData = this.tempRelatedFamilies.map(family => family.value)
    let siblingsData = this.relatedFamilySiblings.filter((item) => !valueCheckData.includes(item.id)).map(res => ({ edit: res.familyName, label: res.familyName, value: res.id }))
    siblingsData = siblingsData.filter(sibling => parseInt(sibling.value) !== parseInt(this.submission.userMetaData.family.pimFamilyId))
    if (siblingsData.length > 0) {
      this.tempRelatedFamilies.push(...siblingsData)
      await this.$nextTick()
    }
    if (this.$refs.familySelect) {
      this.$refs.familySelect.showPills = true
    }
    this.postFamiliesValues(this.tempRelatedFamilies)
    this.tempRelatedFamilies = []
    this.selectedFamily = {}
    this.isFamilySiblingModalVisible = false
    this.hide()
  },
  async getFamiliesOptions(search, loading) {
    /**
     * Fetch after little delay.
     */
    if (!search.length) return

    this.familiesStopSearching()
    this.familiesInputDelay.set(() => {
      this.fetchFamiliesOptions(search, loading).catch(() => { })
    }, 200)
  },
  async fetchFamiliesOptions(search, loading) {
    /**
     * Fetch results for search.
     */
    try {
      if (!this.isFamiliesSearchAllowed(search)) {
        return []
      } else {
        this.families.loading = loading
        this.families.loading(true)
        await this.$store.dispatch('families/get', {
          name: search,
          id: this.submission.foundry.foundryId,
          submissionId: this.submission.id
        })
        if (!this.families.loading) {
          this.familiesHideDrop = true
          return null
        } else {
          if (loading !== null) {
            this.familiesHideDrop = false
            this.families.loading(false)
          }
          return this.setFamiliesOptions()
        }
      }
    } catch (error) {
      this.familiesHideDrop = false
      this.families.loading(false)
      return []
    }
  },
  familiesDeleteLengthError(search) {
    if (search.length === 0) {
      this.isValidFamiliesLength = false
    }
  },
  setFamiliesOptions() {
    /**
     * Set families options in view.
     * Since families options will be completely refreshed in $store after a new search,
     * the options have to be merged with the current value to keep selected options.
     */
    this.families.setOptions({
      obj: this.familiesList,
      value: 'id',
      name: 'familyName',
      multiple: true
    })
  },
  familiesStopSearching() {
    /**
     * Families loading is set in fetchTagOptions()
     * In case of fetching, loading will be set to null, so after fetch is done,
     * the requested families won't be applied.
     */
    if (this.families.loading) {
      this.families.loading(false)
      this.families.loading = null
    }
    this.familiesInputDelay.clear()
    this.familiesHideDrop = true
    this.clearFamiliesOptions()
  },
  isFamiliesSearchAllowed(search) {
    /** families
     * Don't show the tag options if no search term is entered,
     * or excluded chars are found.
     */
    return (
      search.length >= this.familiesMinLength &&
      search.indexOf(this.familiesExcludeChar) === -1
    )
  },
  focusFamiliesSearch(search) {
    /**
     * Reset unless some valid search term is in the input.
     */
    this.familiesHideDrop = !this.isFamiliesSearchAllowed(search)
    if (search.length < this.familiesMinLength) {
      this.clearFamiliesOptions()
    }
  },
  clearFamiliesOptions() {
    this.$store.dispatch('families/resetFamilies')
    this.setFamiliesOptions()
  },
  getApiFamilies() {
    return {
      id: parseInt(this.submission?.userMetaData?.familyGroup?.id) || 0,
      families: this.families.getApiValues({
        value: 'id',
        name: 'familyName',
        multiple: true
      })
    }
  }
}
